export default {
  badge: 'Kenteken',
  open: 'Maak oop',
  close: 'Maak toe',
  dismiss: 'Verwerp',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Kanselleer',
  },
  dataIterator: {
    noResultsText: 'Geen ooreenstemmende resultate is gevind nie',
    loadingText: 'Laai item...',
  },
  dataTable: {
    itemsPerPageText: 'Rye per bladsy:',
    ariaLabel: {
      sortDescending: 'Gesorteer aflopend.',
      sortAscending: 'Gesorteer oplopend.',
      sortNone: 'Nie gesorteer nie.',
      activateNone: 'Aktiveer om sortering te verwyder.',
      activateDescending: 'Aktiveer om aflopend te sorteer.',
      activateAscending: 'Aktiveer om oplopend te sorteer.',
    },
    sortBy: 'Sorteer volgens',
  },
  dataFooter: {
    itemsPerPageText: 'Aantal per bladsy:',
    itemsPerPageAll: 'Alles',
    nextPage: 'Volgende bladsy',
    prevPage: 'Vorige bladsy',
    firstPage: 'Eerste bladsy',
    lastPage: 'Laaste bladsy',
    pageText: '{0}-{1} van {2}',
  },
  dateRangeInput: {
    divider: 'tot',
  },
  datePicker: {
    itemsSelected: '{0} gekies',
    range: {
      title: 'Kies datums',
      header: 'Voer datums in',
    },
    title: 'Kies datum',
    header: 'Voer datum in',
    input: {
      placeholder: 'Voer datum in',
    },
    ariaLabel: {
      previousMonth: 'Vorige maand',
      nextMonth: 'Volgende maand',
      selectYear: 'Kies jaar',
      previousYear: 'Vorige jaar',
      nextYear: 'Volgende jaar',
      selectMonth: 'Kies maand',
      selectDate: '{0}',
      currentDate: 'Vandag, {0}',
    },
  },
  noDataText: 'Geen data is beskikbaar nie',
  carousel: {
    prev: 'Vorige visuele',
    next: 'Volgende visuele',
    ariaLabel: {
      delimiter: 'Carousel skyfie {0} van {1}',
    },
  },
  calendar: {
    moreEvents: '{0} meer',
    today: 'Vandag',
  },
  input: {
    clear: 'Maak skoon {0}',
    prependAction: '{0} voorafgevoegde aksie',
    appendAction: '{0} bygevoegde aksie',
    otp: 'Voer asseblief OTP-karakter {0} in',
  },
  fileInput: {
    counter: '{0} lêers',
    counterSize: '{0} lêers ({1} in totaal)',
  },
  fileUpload: {
    title: 'Sleep en los lêers hier',
    divider: 'of',
    browse: 'Blaai deur lêers',
  },
  timePicker: {
    am: 'VM',
    pm: 'NM',
    title: 'Kies tyd',
    hour: 'Uur',
    minute: 'Minute',
    second: 'Sekondes',
    notAllowed: 'Waarde word nie toegelaat nie',
  },
  pagination: {
    ariaLabel: {
      root: 'Paginasie-navigasie',
      next: 'Volgende bladsy',
      previous: 'Vorige bladsy',
      page: 'Gaan na bladsy {0}',
      currentPage: 'Huidige bladsy, Bladsy {0}',
      first: 'Eerste bladsy',
      last: 'Laaste bladsy',
    },
  },
  stepper: {
    next: 'Volgende',
    prev: 'Vorige',
  },
  rating: {
    ariaLabel: {
      item: 'Gradering {0} van {1}',
    },
  },
  loading: 'Laai...',
  infiniteScroll: {
    loadMore: 'Laai meer',
    empty: 'Geen meer nie',
  },
  rules: {
    required: 'Hierdie veld is verpligtend',
    email: 'Voer asseblief \'n geldige e-posadres in',
    number: 'Hierdie veld kan slegs syfers bevat',
    integer: 'Hierdie veld kan slegs heelgetalle bevat',
    capital: 'Hierdie veld kan slegs hoofletters bevat',
    maxLength: 'Jy moet \'n maksimum van {0} karakters invoer',
    minLength: 'Jy moet \'n minimum van {0} karakters invoer',
    strictLength: 'Die lengte van die ingevoerde veld is ongeldig',
    exclude: 'Die {0} karakter is nie toegelaat nie',
    notEmpty: 'Kies asseblief ten minste een waarde',
    pattern: 'Ongeldige formaat',
  },
  command: {
    search: 'Tik \'n opdrag of soek...',
  },
  hotkey: {
    then: 'dan',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Up Arrow',
    downArrow: 'Down Arrow',
    leftArrow: 'Left Arrow',
    rightArrow: 'Right Arrow',
    backspace: 'Backspace',
    space: 'Spasie',
    plus: 'plus',
    shortcut: 'Sleutelbordkortpad: {0}',
    or: 'of',
  },
  video: {
    play: 'Speel',
    pause: 'Pouseer',
    seek: 'Soek',
    volume: 'Volume',
    showVolume: 'Wys volumebeheer',
    mute: 'Demp',
    unmute: 'Ontdemp',
    enterFullscreen: 'Volskerm',
    exitFullscreen: 'Verlaat volskerm',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Kies kleur van die skerm af',
      hueSlider: 'Tint',
      alphaSlider: 'Alfa',
      redInput: 'Rooi',
      greenInput: 'Groen',
      blueInput: 'Blou',
      alphaInput: 'Alfa',
      hueInput: 'Tint',
      saturationInput: 'Versadiging',
      lightnessInput: 'Ligtheid',
      hexInput: 'HEX-waarde',
      hexaInput: 'HEX met alfa-waarde',
      changeFormat: 'Verander kleurformaat',
    },
  },
}
